// A reducer which holds the ui state.
// @flow
import ACTIONS from './actions';

export default (
    state: any = {
        editCell: false,
        exerciseModal: false,
        isSaving: false,
        exercises: {}
    },
    action: any
) => {
    switch (action.type) {
        case ACTIONS.SET_EDIT_CELL:
            return {
                ...state,
                editCell: action.editCell,
                cellRef: action.cellRef
            };
        case ACTIONS.UI_CREATE_THUMB:
            let videoThumbnail = 'New';
            if (
                action.video_thumbnail &&
                typeof action.video_thumbnail === 'string'
            ) {
                videoThumbnail = action.video_thumbnail;
            } else if (action.video_thumbnail) {
                videoThumbnail = action.video_thumbnail.thumbnail_medium;
            }

            return {
                ...state,
                exercises: {
                    ...state.exercises,
                    [action.exerciseId]: {
                        videoThumbnail,
                        key: action.exerciseId
                    }
                }
            };
        case ACTIONS.UI_EXERCISE_MODAL:
            return {
                ...state,
                exerciseModal: !state.exerciseModal,
                exercise: action.exercise
            };
        case ACTIONS.UI_SAVING:
            return {
                ...state,
                isSaving: action.isSaving
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/state/reducer/uiTree/reducer.js